// let apiHost = 'http://gp.admin.pentaq.ltd/'
// noinspection HttpUrlsUsage

let apiHost = "https://cfm.admin.pentaq.com/api/"
// let apiHost = "/localhost-api/"
// let apiHost = "/test-api/"

if (location.host === 'cfm.pentaq.ltd') {
  apiHost = "https://cfm.admin.pentaq.ltd/api/"
}

let Api = {
  //嵌套页面
  conventionalGame: apiHost + 'authApi/conventionalGame',

  // conventionalGame: apiHost + 'update/conventionalGame',

  searchGameData: apiHost + 'authApi/searchGameData',

  //裁判端
  judge_login:  apiHost + 'judge/login',
  judge_check_login:  apiHost + 'judge/check_login',

  judge_subcontest_player_list:  apiHost + 'judge/subcontest_player_list',
  judge_contest_list:  apiHost + 'judge/contest_list',
  judge_subcontest_list:  apiHost + 'judge/subcontest_list',
  judge_subcontest_match_list:  apiHost + 'judge/subcontest_match_list',
  judge_match_map_list:  apiHost + 'judge/match_map_list',
  judge_round_list:  apiHost + 'judge/round_list',
  judge_set_round_win_way: apiHost + 'judge/set_round_win_way',

  judge_set_match_map_mvp:  apiHost + 'judge/set_match_map_mvp',
  judge_set_subcontest_match_mvp:  apiHost + 'judge/set_subcontest_match_mvp',
  judge_start_match_queue:  apiHost + 'judge/start_match_queue',
  judge_set_contest_default:  apiHost + 'judge/set_contest_default',

  judge_control_api:  apiHost + 'judge/control_api',
  judge_map_list:  apiHost + 'judge/map_list',
  judge_team_player_list:  apiHost + 'judge/team_player_list',

  judge_player_list:  apiHost + 'judge/player_list',

  judge_match_Forecast:  apiHost + 'judge/getMatchForecastData',

  judge_weapon_list:  apiHost + 'judge/weapon_list',

  searchOBPlayerData: apiHost + 'authApi/searchOBPlayerData',

  getGameOverData: apiHost + 'authApi/getGameOverData',

  // 海报
  getWeaponData: apiHost + 'poster/getWeaponData',
  getPlayerData: apiHost + 'poster/getPlayerData',
  getPlayerGameData: apiHost + 'poster/getPlayerGameData',
  getBestPlayerData: apiHost + 'poster/getBestPlayerData', // 最佳选手
  getBestTeamData: apiHost + 'poster/getBestTeamData', // 最佳阵容

  uploadCityGameData: apiHost + 'UploadExcel/uploadCityGameData', // 上传文件

  // 选手雷达图
  getPlayerRadar:apiHost + 'authApi/player/getPlayerRadarData',

   // 直转播工具
   VSPOteamData: apiHost + 'vspo/VSPOteamData',  // 队伍列表
   delVSPOData: apiHost + 'vspo/delVSPOData',  // 重置数据
   saveVSPOData: apiHost + 'vspo/saveVSPOData',  // 保存数据
   searchVSPOData:apiHost + 'vspo/searchVSPOData', // 查询已保存数据
}

export {Api}



// WEBPACK FOOTER //
// ./src/api/config.js